<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['triggerNavigationEvent']);

const triggerNavigationEvent = () => {
  emit('triggerNavigationEvent')
}

defineProps({
  aiSitemap: {
    type: Boolean,
    required: false,
    default: true,
  },
  disabledButton: {
    type: Boolean,
    required: false,
    default: false,
  }
});
</script>

<template>
  <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
    <div
      class="tw-flex tw-gap-8 tw-items-center"
    >
      <div
        class="tw-rounded-full tw-p-3 tw-border-4 tw-border-everest-bright tw-bg-everest-lightest!"
      >
        <svg-vue
          class="tw-w-9 tw-text-everest-bright"
          icon="icons/tick-thin"
        />
      </div>

      <div class="tw-flex tw-flex-col tw-justify-between tw-items-start">
        <p class="tw-font-bold tw-text-grey-dark tw-text-2.5xl">
          Success
        </p>
        <p class="tw-text-base tw-text-font-secondary">
          {{ aiSitemap ? 'Your chosen keywords have been mapped to your website pages' : 'Your keywords have been generated' }}
        </p>
      </div>
    </div>

    <DefaultButton
      additional-classes="tw-relative"
      size="2xlarge"
      :disabled="disabledButton"
      @click="triggerNavigationEvent"
    >
      <span class="tw-flex-grow">Continue</span>
      <svg-vue
        class="tw-w-6 tw-h-6 tw-absolute tw-right-3.5"
        icon="icons/arrow-right"
      />
    </DefaultButton>
  </div>
</template>
